import styled from "styled-components";

const StyledInput = styled.input`
    padding: 2px 7px;
    outline: none
`

export const S = {
  StyledInput
}